import { Component, inject } from '@angular/core';
import { SettingsSliderComponent } from '../../../../common/components/base-settings-dialog/settings-slider/settings-slider.component';
import { Settings, SettingsOriginator, SettingsService } from '../../../../services/settings/settings.service';
import { ButtonComponent } from '../../../../common/components/button/button.component';
import { FormsModule } from '@angular/forms';
import { MatrixService } from '../../../../services/matrix/matrix.service';
import { NotificationSettingsTestIds } from './notification-settings.test-ids';
import { PresenceService } from '../../../../services/presence/presence.service';
import { preventInvalidNumberInput } from '../../../../services/util';

@Component({
  selector: 'app-notification-settings',
  imports: [SettingsSliderComponent, ButtonComponent, FormsModule],
  templateUrl: './notification-settings.component.html',
  styleUrl: './notification-settings.component.scss'
})
/**
 * Komponente zur Einstellung der Benachrichtigungeneinstellungen. Erfüllte Afos hierdurch sind.
 *
 *
 * A_25609 - Konfigurierbare Frist für die Raumlöschung
 * A_25610 - Default muss 6 Monate sein
 */
export class NotificationSettingsComponent /*implements OnInit */ {
  maxDeletionPeriod: number | undefined = 24;
  infoText = 'ausschalten, um Benachrichtigungen für die Raumevents zu deaktivieren';
  infoTitle = 'Benachrichtigungen ausschalten';
  protected readonly testIds = NotificationSettingsTestIds;
  protected readonly settingsOriginator = new SettingsOriginator(Settings.getInstance());
  private readonly settingsService = inject(SettingsService);
  private readonly matrix = inject(MatrixService);
  private readonly presenceService = inject(PresenceService);

  /*
    Code wird später wieder verwendet, sobald der angesprochene Endpunkt gefixt ist, solange ist der Code auskommentiert,
    da er einen Anwendungsabsturz provizieren kann
   */
  /*ngOnInit(): void {
    this.getDeletionPeriodFromBackend();
  }*/

  /*getDeletionPeriodFromBackend(): void {
    const client = this.matrix.client;
    this.settingsService
      .getDeletionPeriod(client)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe({
        next: (resp: DeleteResponse) => {
          this.maxDeletionPeriod = this.convertToMonth(resp.loeschFrist);
        }
      });
  }
  convertToMonth(deletePeriodInSeconds: number): number {
    const minutes = deletePeriodInSeconds / 60;
    const hours = minutes / 60;
    const days = hours / 24;
    return Math.round(days / 30.417); // Approx days in a month
  }*/

  async saveSettings(): Promise<void> {
    await this.settingsService.saveSettings(this.matrix.client, this.settingsOriginator.state);
    await this.presenceService.updateCurrentUserPresence();
  }

  async getDeletionPeriodFromBackend(): Promise<void> {
    const resp = await this.settingsService.getDeletionPeriod(this.matrix.client);
    this.maxDeletionPeriod = this.convertToMonth(resp.loeschFrist);
  }

  convertToMonth(deletePeriodInSeconds: number): number {
    const minutes = deletePeriodInSeconds / 60;
    const hours = minutes / 60;
    const days = hours / 24;
    return Math.round(days / 30.417); // Approx days in a month
  }

  protected readonly preventInvalidNumberInput = preventInvalidNumberInput;
}
